type Props = {
  children: React.ReactNode;
};

const Title = ({ children }: Props) => {
  return <h1 className='text-xl font-medium'>{children}</h1>;
};

export default Title;
